// @core/api/endpoints/form/update_form_type.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  FormTypeDefinitionResponse,
  UpdateFormTypeRequest,
} from '../../../types/form';

const BASE_PATH = '/form';

/**
 * Update form type
 * Updates a form type definition (submission rules, template, review workflow).
 */
export async function UpdateFormType(
  type_id: string,
  data: UpdateFormTypeRequest,
  options?: RequestOptions
): Promise<FormTypeDefinitionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/form-types/:type_id`;
  requestPath = requestPath.replace(':type_id', encodeURIComponent(type_id));
  const requestOptions = options;
  return client.put<FormTypeDefinitionResponse>(requestPath, data, requestOptions);
}
